import { Navigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import { AppLayout } from './AppLayout'

/**
 * Route shell for authenticated views. Redirects to /login when the auth
 * store reports an unauthenticated state; otherwise renders the
 * AppLayout (sidebar + topbar + <Outlet/>).
 */
export function ProtectedShell() {
  const { isAuthenticated } = useAuth()
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  return <AppLayout />
}
